export default __webpack_public_path__ + "static/media/cardboard.a4cbcf42.jpg";